module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460963.d5de2b6a.png";